import { Verb } from "modules/roles/schemas/rolesSchemas";
import hasRightForEndpoint from "modules/roles/helpers/hasRightForEndpoint";
import { useSelfcare } from "modules/selfcare/hooks/useSelfcare";
import { ENDPOINTS } from "modules/shared/webservices/constants/endpoints";

export function useHasRightForComment(verb: Verb) {
  const { data } = useSelfcare(false);
  return hasRightForEndpoint(ENDPOINTS.COMMENTS, [verb], data?.routes);
}
